import { render } from "./AnchorAgreement.vue?vue&type=template&id=8abcaddc&scoped=true"
import script from "./AnchorAgreement.vue?vue&type=script&lang=js"
export * from "./AnchorAgreement.vue?vue&type=script&lang=js"

import "./AnchorAgreement.vue?vue&type=style&index=0&id=8abcaddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8abcaddc"]])

export default __exports__